import React, { useState } from 'react';
import { ChevronDown, Menu, X, Phone } from 'lucide-react';

const Office24by7Landing = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8f9fa' }}>
    
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-[#393737] mb-4">
            Empower Your Business 24by7. Efficiency
          </h1>
          <h2 className="text-3xl md:text-2xl lg:text-3xl font-bold text-gray-900">
            Served Every Time!
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {/* Card 1 - Single page browser */}
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="mb-6">
              <div className="w-full h-48 rounded-xl mb-6 flex items-center justify-center" style={{ backgroundColor: '#4285f4' }}>
              <img src="https://images.unsplash.com/photo-1516572541403-d8d1ef5b8844?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8d2ViJTIwYnJvd3NlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Single page browser.
            </h3>
            <h4 className="text-xl font-semibold text-gray-900 mb-4">
              Convenience personified.
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Thinking technology is complex? Think no more. Manage your business with a personalized, "upgradable and flawless" user experience.
            </p>
          </div>

          {/* Card 2 - Business anywhere-anytime */}
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="mb-6">
              <div className="w-full h-48 rounded-xl mb-6 flex items-center justify-center" style={{ backgroundColor: '#2d1b69' }}>
             <img src="" alt="" />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Business anywhere-anytime.
            </h3>
            <h4 className="text-xl font-semibold text-gray-900 mb-4">
              Go mobile.
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Access your business with our mobile app. Take tactical decisions and execute full-fledged organizational operations on the go — anywhere, anytime.
            </p>
          </div>

          {/* Card 3 - Hierarchical monitoring */}
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="mb-6">
              <div className="w-full h-48 rounded-xl mb-6 flex items-center justify-center" style={{ backgroundColor: '#ff9800' }}>
               <img src="" alt="" />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Hierarchical monitoring &
            </h3>
            <h4 className="text-xl font-semibold text-gray-900 mb-4">
              transparency.
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Nothing gets lost in translation. From CXO to executives, define your hierarchy and monitor the progress. Work towards a unified goal with a clear understanding of what, how, and where.
            </p>
          </div>
        </div>
      </main>

   
    </div>
  );
};

export default Office24by7Landing;